import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="request"
export default class extends Controller {
  static values = { defaultParams: { type: Object, default: {} }, params: { type: Object, default: {} } }
  static targets = ["trigger"]
  connect() {
    for (const [param, elementId] of Object.entries(this.paramsValue)) {
      let elements = document.querySelectorAll(`#${elementId}`)
    }
  }

  request() {
    if (this.#validateParams()) return

    let searchParams = new URLSearchParams()

      for (const [param, elementId] of Object.entries(this.paramsValue)) {
        let elements = document.querySelectorAll(`#${elementId}`)
        let element = Array.from(elements).find(element => element.value)
        if (element) {
          if (element.tagName === 'SELECT') {
            searchParams.append(param, element.options[element.selectedIndex].text)
          }
          else {
            searchParams.append(param, element.value)
          }
        }
      }

      for (const [param, value] of Object.entries(this.defaultParamsValue)) {
        searchParams.append(param, value)
      }

      let trigger = this.hasTriggerTarget ? this.triggerTarget : this.element
      trigger.href = trigger.href.split("?")[0]
      trigger.href = `${trigger.href}?${searchParams}`
      this.hasTriggerTarget ? trigger.click() : null
  }

  #validateParams() {
    let anyReported = false
    for (const [param, elementId] of Object.entries(this.paramsValue)) {
      let elements = document.querySelectorAll(`#${elementId}`)
      let anyElementHasValue = false
      elements.forEach(element => {
        if (element.value) {
          anyElementHasValue = true
        }
      })
      if (!anyElementHasValue) {
        elements[0].reportValidity()
        elements[0].focus()
        anyReported = true
      }
    }
    return anyReported
  }
}
